(() => {
  if (!/^\/app\/play(?:\.html)?$/.test(location.pathname) || new URLSearchParams(location.search).get('c') !== '1') return;
  if (window.BGSALES) return;
  let dialog, frame, trigger;
  const dismiss = () => {
    if (!dialog?.open) return;
    frame?.contentDocument?.querySelectorAll('video,audio').forEach(media => media.pause());
    dialog.close();
  };
  const close = () => { if (window.BGPAY?.busy()) return; dismiss(); const home = document.getElementById('home'); if (home) home.click(); else location.assign('/#home'); };
  const state = () => {
    const menu = window.BGPAY?.menu();
    const children = [...(document.getElementById('vpanel')?.children || [])];
    const toc = children.findIndex(el => el.classList.contains('tocl') || el.classList.contains('toc'));
    const free = toc < 0 ? [] : children.slice(0, toc).filter(el => !el.classList.contains('hr'));
    const available = [...document.querySelectorAll('#vpanel .toc li')].map((li, index) => ({index, available: !li.classList.contains('nope')}));
    return {price: menu?.애플값 || (menu?.값 ? Number(menu.값).toLocaleString('ko-KR') + '원' : ''), count: menu?.파는 ?? available.filter(part => part.available).length, disabled: !menu || !!trigger?.disabled || !!window.BGPAY?.busy(), canProceed: !!menu?.탈 || menu?.mode === 'off' || !!menu?.샀나, buttonText: menu?.탈 ? '가격 다시 확인' : menu?.샀나 ? '결과 보기' : (window.BGLANG?.sourceText(trigger) ?? trigger?.textContent)?.trim().startsWith('결제 확인') ? '결제 확인' : '재회 풀이 구매하기', freeHTML: free.map(el => el.outerHTML).join(''), readingCss: document.querySelector('link[href*="reading-format"]')?.href, available};
  };
  const purchase = () => {
    if (!dialog?.open || !trigger?.isConnected || trigger.disabled || window.BGPAY?.busy()) return;
    const original = trigger.onclick;
    original?.call(trigger);
    setTimeout(bind, 0);
  };
  window.BGSALES = {state, purchase, close};
  const open = button => {
    trigger = button;
    button.closest('#vpanel').setAttribute('data-reunion-page', '');
    button.hidden = true;
    button.setAttribute('data-reunion-payment-control', '');
    if (!dialog) {
      const style = document.createElement('style');
      style.textContent = '#vpanel[data-reunion-page],#payBtn[data-reunion-payment-control]{display:none!important}body:has(#bg-reunion-sales[open]) #toast{position:fixed;z-index:101}#bg-reunion-sales{position:fixed;inset:0;width:100vw;height:100dvh;max-width:none;max-height:none;margin:0;padding:0;border:0;background:#000;overflow:hidden;z-index:100}#bg-reunion-sales iframe{width:100%;height:100%;border:0;display:block}#bg-reunion-sales .sales-close{position:absolute;top:max(12px,env(safe-area-inset-top));right:max(12px,env(safe-area-inset-right));width:44px;height:44px;display:grid;place-items:center;padding:0;border-radius:50%;background:var(--glass,rgba(28,28,30,.62));-webkit-backdrop-filter:var(--glass-blur,blur(24px));backdrop-filter:var(--glass-blur,blur(24px));border:.5px solid var(--glass-edge,rgba(255,255,255,.12));color:#fff;font-size:17px;font-weight:600;cursor:pointer}#bg-reunion-sales .sales-close:focus-visible{outline:2px solid var(--tint,#FFB800);outline-offset:3px}';
      document.head.append(style);
      dialog = document.createElement('dialog');
      dialog.id = 'bg-reunion-sales';
      dialog.setAttribute('aria-label', '백하연 재회 풀이 구매 안내');
      frame = document.createElement('iframe');
      frame.title = '백하연 재회 풀이 구매 안내';
      const button = document.createElement('button');
      // 10/8 애플 기준 — 닫기는 SF Symbols xmark · 44 · 유리, 이름은 다른 홈 단추와 같은 「홈으로」
      button.type = 'button'; button.className = 'sales-close'; button.innerHTML = '<span class="sf sf-xmark" aria-hidden="true"></span>'; button.setAttribute('aria-label', '홈으로'); button.onclick = close;
      dialog.append(frame, button); document.body.append(dialog);
      dialog.addEventListener('cancel', event => {event.preventDefault();close();});
    }
    if (!frame.getAttribute('src')) frame.src = window.BGLANG?.link('/promo/baek-reunion-sales-v1/checkout.html') ?? '/promo/baek-reunion-sales-v1/checkout.html';
    if (!dialog.open) dialog.showModal();
  };
  const bind = () => {
    const button = document.getElementById('payBtn');
    if (button?.closest('#vpanel') && document.getElementById('verdict')?.classList.contains('on')) open(button);
    else { dismiss(); if (!button) document.getElementById('vpanel')?.removeAttribute('data-reunion-page'); }
  };
  new MutationObserver(bind).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['class','disabled']});
  bind();
})();
